<template>
  <ul class="nav nav-tabs nav-fill" :class="[directionClass, alignClass]">
    <slot></slot>
  </ul>
</template>

<script>
import { TabEventBus } from './EventBus.js'

export default {
  name: 'Tabs',
  props: {
    vertical: { type: Boolean },
    right: { type: Boolean },
    bottom: { type: Boolean },
    target: { type: String, required: true },
    value: { type: Number, default: 0 }
  },
  provide () {
    return {
      elProp: this.elProp
    }
  },
  data () {
    return {
      elProp: {
        vertical: this.vertical,
        activeTab: null
      }
    }
  },
  computed: {
    directionClass () {
      return {
        tabs__vertical: this.vertical
      }
    },
    alignClass () {
      return {
        tabs__right: this.right,
        tabs__bottom: this.bottom
      }
    }
  },
  mounted () {
    if (this.$children.length > 0) {
      this.$children[this.value].isActive = true
    }
  },
  methods: {
    deactiveOtherTabs (selectedTab) {
      this.$children
        .filter(tab => tab !== selectedTab)
        .forEach(tab => {
          tab.isActive = false
        })
    }
  },
  watch: {
    'elProp.activeTab': {
      handler (selectedTab) {
        this.deactiveOtherTabs(selectedTab)
        TabEventBus.$emit('tabchange', {
          target: this.target,
          index: this.$children.indexOf(selectedTab)
        })
        this.$emit('change', this.$children.indexOf(selectedTab))
      }
    },
    activeKey: function (value) {
      if (this.$children.length > 0) {
        this.$children[value].isActive = true
      }
    },
    value: {
      handler (val) {
        if (this.$children.length > 0) {
          this.$children[val].isActive = true
        }
      },
      immediate: true
    }
  }
}
</script>
